import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextInput, TextArea, Checkbox } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function FacilitationRailsGatherPage() {
  const [dibbExplanation, setDibbExplanation] = useState('');
  const [mergedCount, setMergedCount] = useState('');
  const [backlogReady, setBacklogReady] = useState(false);
  const [reviewOnCalendar, setReviewOnCalendar] = useState(false);

  return (
    <TaskPage
      phase="gather"
      title="Facilitation Rails & Retrieval Check"
      pageNumber={8}
      instruction="Quick recall to strengthen memory and follow-through. Suggested timing: 60–90 min total (G1 10 · G2 10 · G3 10 · G4 15 · G5 10 · G6 10–15 · G7 10–15 · Close 5)"
      whyItMatters="Retrieval at the end of a segment strengthens memory and follow-through; repeat in later modules for spacing benefits."
      coachRail={{
        timing: "3-5 minutes",
        tips: "Opener: 'name one wildcard idea you're secretly excited about.' Closer: 'one item I'll defend + one I'm fine parking.'",
        debrief: "Review date for the Later pile is on the calendar ☐"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Quick Recall</h3>
          <div className="space-y-4">
            <TextArea
              label="I can explain the DIBB behind our #1 option"
              value={dibbExplanation}
              onChange={(e) => setDibbExplanation(e.target.value)}
              placeholder="What's the DIBB (Data/Insight/Belief/Bet) for our top option?"
              rows={3}
            />
            <TextInput
              label="We merged __ duplicate items"
              value={mergedCount}
              onChange={(e) => setMergedCount(e.target.value)}
              placeholder="How many duplicates did we merge?"
            />
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={backlogReady}
                onChange={(e) => setBacklogReady(e.target.checked)}
                label="Our backlog has ≤20 items ready for Arrange"
              />
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={reviewOnCalendar}
                onChange={(e) => setReviewOnCalendar(e.target.checked)}
                label="Review date for the Later pile is on the calendar"
              />
            </label>
          </div>
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Facilitation Notes</h3>
          <div className="space-y-2 text-sm text-[var(--text-sec)]">
            <p><strong>Opener:</strong> "name one wildcard idea you're secretly excited about."</p>
            <p><strong>Closer:</strong> "one item I'll defend + one I'm fine parking."</p>
            <p className="mt-4"><strong>Suggested timing:</strong> 60–90 min total</p>
            <ul className="list-disc list-inside ml-4 mt-2">
              <li>G1: 10 min</li>
              <li>G2: 10 min</li>
              <li>G3: 10 min</li>
              <li>G4: 15 min</li>
              <li>G5: 10 min</li>
              <li>G6: 10–15 min</li>
              <li>G7: 10–15 min</li>
              <li>Close: 5 min</li>
            </ul>
          </div>
        </div>

        <Callout type="tip" phase="gather">
          <p className="text-sm">Retrieval at the end strengthens memory. Repeat in later modules for spacing benefits.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






